import axios from "axios";
import { fetchPut, fetchGet } from "../../api_client";

import { AddressModel } from "../../models/address_model";

export const UpdateBillingAddressApi = async ({
  uid,  
  type,
  address,
  branch,
}: {
  uid: string;
  type: string;
  address: AddressModel;
  branch: string;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/orders/billing-profile/${uid}/address?type=${type}&branch=${branch}`;
    const res = await fetchPut(url, address);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getStatesApi = async () => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/place/states`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getCitiesApi = async (state: string) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v1/place/cities?state=${state}`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
export const getCityStateApi = async (pincode: number) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/address/pincode/${pincode}`;
    const res = await fetchGet(url);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const updateDeliveryAddressApi = async ({
  uid,
  type,
  address,
  branch,
}: {
  uid: string;
  type: string;
  address: AddressModel;
  branch: string;
}) => {
  try {
    const url = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/orders/billing-profile/${uid}/address?type=${type}&branch=${branch}`;
    const res = await fetchPut(url, address);

    return res;
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};